import classnames from 'classnames';
import React from 'react';

import css from './defaultIconStyles.css';

export const IconArrowRevert = ({
    width = '16',
    height = '16',
    className = '',
    ...rest
}) => (
    <svg
        width={width}
        height={height}
        xmlns="http://www.w3.org/2000/svg"
        className={classnames(css.main, className)}
        {...rest}
    >
        <g fillRule="evenodd">
            <path d="M5.271 3.746l.792 1.371c.247.428.138.952-.241 1.172a.745.745 0 0 1-.544.075L1.24 5.641a.93.93 0 0 1-.646-.462.931.931 0 0 1-.078-.791L1.91.529a.74.74 0 0 1 .336-.433c.38-.219.889-.05 1.135.377l.89 1.541A7.455 7.455 0 0 1 7.942.999h.193a7.473 7.473 0 0 1 3.073.701 7.565 7.565 0 0 1 3.55 3.465c.329.662.558 1.371.679 2.1.13.784.135 1.588.015 2.374a7.444 7.444 0 0 1-.694 2.192 7.524 7.524 0 0 1-3.885 3.612A7.503 7.503 0 0 1 .814 10.514l-.002-.005a1.002 1.002 0 0 1 1.937-.508l.026.096a5.55 5.55 0 0 0 1.422 2.336 5.49 5.49 0 0 0 3.77 1.565 5.515 5.515 0 0 0 2.087-.381 5.516 5.516 0 0 0 3.399-6.093 5.49 5.49 0 0 0-.486-1.469 5.558 5.558 0 0 0-2.546-2.515A5.555 5.555 0 0 0 8.181 3c-.071-.001-.142-.002-.214-.001a5.543 5.543 0 0 0-2.696.747z" />
        </g>
    </svg>
);

export default IconArrowRevert;
